import { COLOR_OPTIONS } from 'config/style';
import { useTranslation } from 'react-i18next';
import { RiskLevelBadge, RiskLevelBadgesContainer } from './info-modal.style';

// Configuration object mapping risk levels to their color tokens and translation keys
const RISK_LEVEL_CONFIG = [
  {
    key: 'no_risk',
    background: COLOR_OPTIONS.NEUTRAL_30,
    color: COLOR_OPTIONS.NEUTRAL_80,
    translationKey: 'pages.regional_overview.regional_risk.level_risk.no_risk'
  },
  {
    key: 'low_risk',
    background: COLOR_OPTIONS.GREEN_50,
    color: COLOR_OPTIONS.WHITE,
    translationKey: 'pages.regional_overview.regional_risk.level_risk.low_risk'
  },
  {
    key: 'medium_risk',
    background: COLOR_OPTIONS.YELLOW_40,
    color: COLOR_OPTIONS.NEUTRAL_80,
    translationKey: 'pages.regional_overview.regional_risk.level_risk.medium_risk'
  },
  {
    key: 'high_risk',
    background: COLOR_OPTIONS.RED_60,
    color: COLOR_OPTIONS.WHITE,
    translationKey: 'pages.regional_overview.regional_risk.level_risk.high_risk'
  }
];

export const RiskLevelBadges = () => {
  const [t] = useTranslation();
  return (
    <RiskLevelBadgesContainer>
      {RISK_LEVEL_CONFIG.map(({ key, background, color, translationKey }) => (
        <RiskLevelBadge key={key} $background={background} $color={color}>
          {t(translationKey)}
        </RiskLevelBadge>
      ))}
    </RiskLevelBadgesContainer>
  );
};
